import styled from "styled-components/macro";

const Container = styled.div`
  .list:not(:first-child) {
    margin-left: 20px;
  }

  span {
    font-size: 20px;
  }

  .content {
    margin-left: 20px;
  }
`;

export default Container;
